import { connect } from 'react-redux';
import CustomiseMenu from './CustomiseMenu';

const mapStateToProps = (state, ownProps) => ({
  ...state,
  ...ownProps,
});

export default connect(mapStateToProps)(CustomiseMenu);
